import { useIsTokenListed } from '@trustpad/launchpad';

import * as React from 'react';
import { ChainLabel } from 'src/features/pools/components/ChainLabel/ChainLabel';

import { SocialLinks } from '~common/components/SocialLinks';
import { LaunchProtocolProtected } from '~features/pools/components/PoolSecondaryBlock/LaunchProtocolProtected';

import { PoolConfig, PoolToken } from '../../types';
import { AddMetamaskTokenButton } from '../AddMetamaskTokenButton';

function TokenImage({
  imageSrc,
  symbol,
}: Pick<PoolToken, 'imageSrc' | 'symbol'>) {
  return (
    <div style={{ width: '45px', height: '45px' }}>
      <img src={imageSrc} alt={symbol} className="h-full rounded-full" />
    </div>
  );
}

export function Header({
  token,
  description,
  social,
  launchProtected,
}: {
  token: PoolToken;
  description: PoolConfig['description'];
  social: PoolConfig['social'];
  launchProtected?: boolean;
}) {
  const { isListed } = useIsTokenListed();

  return (
    <div className="pb-3 flex flex-col gap-6">
      <div className="flex items-start justify-between flex-wrap">
        <div className="flex items-center mb-3 md:mb-0">
          <div className="mr-3">
            <TokenImage {...token} />
          </div>

          <h2 className="text-2xl font-secondary tracking-wide mb-0">
            {token.name}
          </h2>
        </div>
        <div className="space-x-3 flex items-center">
          <ChainLabel chain={token.chain} />
          {token.extraChains?.map((chain) => (
            <ChainLabel key={chain} chain={chain} />
          ))}
        </div>
      </div>

      <div className="opacity-80 space-y-3 -mt-3">{description}</div>

      {launchProtected && (
        <div>
          <LaunchProtocolProtected />
        </div>
      )}

      {social?.announcement && (
        <p>
          <a
            href={social.announcement}
            className="text-main"
            target="_blank"
            rel="noreferrer">
            Read more
          </a>
        </p>
      )}

      {social?.voting && (
        <p>
          <a href={social?.voting}>{token.name} refund voting</a>
        </p>
      )}

      <div className="space-x-6 flex items-center">
        <SocialLinks social={social} />

        {isListed && <AddMetamaskTokenButton token={token} />}
      </div>
    </div>
  );
}
